// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import DigitalCity from '@/assets/img/DigitalCity.png';
// import OnStreet from '@/assets/img/TaifContract-onStreet.png';
// import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
// import CarPark from '@/assets/img/TaifContract-carPark.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import LoadingComponent from '@/components/common/LoadingComponent';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser', group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//     { group_name: 'Ticket Verifier', group_total_qty: o.ticketVerifier ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//     { group_name: "APM's", group_total_qty: o.apms ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//     { group_name: 'PIN Pad', group_total_qty: o.pinPad ?? '-', items: [{ item_name: 'IUP250', qty: o.iup250 ?? '-' }] },
//     { group_name: 'Card Reader', group_total_qty: o.cardReader ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
//     { group_name: 'B-Contactless', group_total_qty: o.bContactless ?? '-', items: [{ item_name: 'IUC150', qty: o.iuc150 ?? '-' }] },
//     { group_name: 'RFID Reader', group_total_qty: o.rfidReader ?? '-', items: [] },
//     { group_name: 'IP Barrier', group_total_qty: o.ipBarrier ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA', group_total_qty: o.anprCamera ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: '-' }] },
//     { group_name: 'Sliding Gate', group_total_qty: o.slidingGate ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
//     { group_name: "PND's", group_total_qty: o.pnds ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
//     { group_name: 'Driver Device', group_total_qty: '-', items: [{ item_name: 'CN-51', qty: '-' }] },
//     { group_name: 'Enf Device', group_total_qty: o.enfDevice ?? '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
//     { group_name: 'Validation', group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//     { group_name: 'Printer', group_total_qty: o.printer ?? '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
//     { group_name: 'Tow Truck', group_total_qty: o.towTruck ?? '-', items: [] },
//     { group_name: 'Clamp Vehicle', group_total_qty: o.clampVehicle ?? '-', items: [] },
//     { group_name: 'Support Vehicle', group_total_qty: o.supportVehicle ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const DIGITAL_CITY_ON_STREET_CONFIG = {
//   digital_city_on_street_profile: {
//     profileKey: 'digital_city_on_street_profile',
//     violationKey: 'digital_city_on_street_violations',
//     statisticsKey: 'digital_city_on_street_statistics',
//     assetsKey: 'digital_city_on_street_assets',
//     pageType: 'on_street',

//     profileFallback: {
//       table_key: 'digital_city_on_street_profile',
//       title: 'Digital City On Street - Profile',
//       data: {
//         total_bays: { label: 'Total On-Street Parking Bays', value: '328' },
//         contract_term: { value: '05 years' },
//         contract_period: { start_date: '01st April 2025', end_date: '31st March 2030' },
//         operational_hours: { value: '12 Hours Per day', from: '6:00', to: '18:00' },
//         closed_days: { value: '(Friday and Saturday Closed)' },
//         rate_per_hour: { value: 'SAR 10 per hour + 15% vat' },
//       },
//     },

//     violationFallback: {
//       table_key: 'digital_city_on_street_violations',
//       title: 'ON STREET VIOLATIONS',
//       data: {
//         violation_groups: [
//           {
//             group_name: '1st Violation Group',
//             rows: [
//               { violation_type: 'Parking without paying', amount: '200' },
//               { violation_type: 'Expired Ticket', amount: '100' },
//               { violation_type: 'Exceeding the maximum time allowed to park', amount: '100' },
//               { violation_type: 'Not parked within the parking space', amount: '100' },
//             ],
//           },
//           {
//             group_name: '2nd Violation Group',
//             rows: [
//               { violation_type: 'Parked in an official reserved space', amount: '300' },
//               { violation_type: 'Parked in a prohibited parking space', amount: '300' },
//             ],
//           },
//           {
//             group_name: '3rd Violation Group',
//             rows: [
//               { violation_type: 'Placing obstacles or reservations on the parking space', amount: '400' },
//             ],
//           },
//           {
//             group_name: '4th Violation Group',
//             rows: [
//               { violation_type: 'Parking in front of doorway, pedestrian crossing, building vehicle entry and exit lanes', amount: '900' },
//               { violation_type: 'Parked the Vehicle on pedestrian area, double parking or buildings\' entries and exits', amount: '500' },
//             ],
//           },
//         ],
//         details: [
//           {
//             detail_type: 'Towing / Removals',
//             columns: ['Light Vehicle', 'Large Vehicle', 'Daily Storage - Light vehicle', 'Daily Storage - Large vehicle (from day2)'],
//             values: ['300', '1000', '', '300'],
//           },
//           {
//             detail_type: 'Clamp removal fee',
//             columns: ['Light Vehicles / Motorbikes', 'Large Vehicles/Buses, Trucks, and Vans'],
//             values: ['300', '1000'],
//           },
//         ],
//       },
//     },

//     statisticsFallback: {
//       table_key: 'digital_city_on_street_statistics',
//       title: 'PARKING STATISTICS',
//       data: {
//         rows: [
//           { area: 'ON STREET PARKING', parking_spaces: '247' },
//           { area: 'TE-01 (PART 1)', parking_spaces: '221' },
//           { area: 'MASJID PARKING', parking_spaces: '13' },
//           { area: 'BUILDING FORECOURT', parking_spaces: '68' },
//           { area: 'TOTAL', parking_spaces: '594' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'digital_city_on_street_assets',
//       title: 'Digital City On-Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '1', evDipG100: '1',
//           apms: '-', pinPad: '30', iup250: '30',
//           cardReader: '-', bContactless: '30', iuc150: '30',
//           rfidReader: '-', ipBarrier: '-', anprCamera: '-',
//           slidingGate: '2', right: '1', left: '1',
//           pnds: '-', enfDevice: '8', doogee: '8',
//           printer: '12', bixolon: '12',
//           towTruck: '-', clampVehicle: '-', supportVehicle: '1',
//         }),
//       },
//     },
//   },
// };

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const DigitalCityOnStreetProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = DIGITAL_CITY_ON_STREET_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [profileData, setProfileData] = useState(null);
//   const [assetsData, setAssetsData] = useState(null);
//   const [violationData, setViolationData] = useState(null);
//   const [statisticsData, setStatisticsData] = useState(null);
//   const { enqueue } = useApiQueue();

//   // Refs for profile inputs
//   const totalBaysRef = useRef(null);
//   const contractTermRef = useRef(null);
//   const contractStartDateRef = useRef(null);
//   const contractEndDateRef = useRef(null);
//   const operationalHoursValueRef = useRef(null);
//   const operationalHoursFromRef = useRef(null);
//   const operationalHoursToRef = useRef(null);
//   const closedDaysRef = useRef(null);
//   const ratePerHourRef = useRef(null);

//   // Refs for violation groups
//   const violationGroupRefs = useRef([]);
//   const violationAmountRefs = useRef([]);

//   // Refs for statistics
//   const statisticsAreaRefs = useRef([]);
//   const statisticsSpacesRefs = useRef([]);

//   // Refs for assets
//   const assetSubCountRefs = useRef([]);
//   const assetTotalCountRefs = useRef([]);

//   // State refs for data
//   const profileDataRef = useRef(null);
//   const assetsDataRef = useRef(null);
//   const violationDataRef = useRef(null);
//   const statisticsDataRef = useRef(null);

//   const violationDetailTypeRefs = useRef([]);
//   const violationDetailColumnsRefs = useRef([]);
//   const violationDetailValuesRefs = useRef([]);

//   // Fetch data
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       const profile = find(cfg.profileKey, cfg.profileFallback);
//       const assets = find(cfg.assetsKey, cfg.assetsFallback);
//       const violation = find(cfg.violationKey, cfg.violationFallback);
//       const statistics = find(cfg.statisticsKey, cfg.statisticsFallback);

//       setProfileData(profile);
//       setAssetsData(assets);
//       setViolationData(violation);
//       setStatisticsData(statistics);

//       profileDataRef.current = profile;
//       assetsDataRef.current = assets;
//       violationDataRef.current = violation;
//       statisticsDataRef.current = statistics;
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // Auto-save
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   const transformAssetsToApiFormat = () => {
//     const currentAssets = assetsDataRef.current?.data?.groups || [];
//     const groups = [];
//     let currentGroup = null;
//     let flatIdx = 0;

//     currentAssets.forEach((group) => {
//       currentGroup = {
//         group_name: group.group_name,
//         group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
//         items: []
//       };
//       flatIdx++;

//       (group.items || []).forEach((item) => {
//         currentGroup.items.push({
//           item_name: item.item_name,
//           qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
//         });
//         flatIdx++;
//       });

//       groups.push(currentGroup);
//     });

//     return groups;
//   };

//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       // Get current values from refs
//       const currentTotalBays = totalBaysRef.current?.value || profileDataRef.current?.data?.total_bays?.value || '';
//       const currentContractTerm = contractTermRef.current?.value || profileDataRef.current?.data?.contract_term?.value || '';
//       const currentStartDate = contractStartDateRef.current?.value || profileDataRef.current?.data?.contract_period?.start_date || '';
//       const currentEndDate = contractEndDateRef.current?.value || profileDataRef.current?.data?.contract_period?.end_date || '';
//       const currentOperationalHoursValue = operationalHoursValueRef.current?.value || profileDataRef.current?.data?.operational_hours?.value || '';
//       const currentOperationalHoursFrom = operationalHoursFromRef.current?.value || profileDataRef.current?.data?.operational_hours?.from || '';
//       const currentOperationalHoursTo = operationalHoursToRef.current?.value || profileDataRef.current?.data?.operational_hours?.to || '';
//       const currentClosedDays = closedDaysRef.current?.value || profileDataRef.current?.data?.closed_days?.value || '';
//       const currentRatePerHour = ratePerHourRef.current?.value || profileDataRef.current?.data?.rate_per_hour?.value || '';

//       // Build violation groups from refs
//       const currentViolationGroups = (violationDataRef.current?.data?.violation_groups || []).map((group, gIdx) => ({
//         group_name: group.group_name,
//         rows: (group.rows || []).map((row, rIdx) => ({
//           violation_type: violationGroupRefs.current[gIdx]?.[rIdx]?.type?.value || row.violation_type || '',
//           amount: violationAmountRefs.current[gIdx]?.[rIdx]?.amount?.value || row.amount || ''
//         }))
//       }));

//       // YEH LINE ADD KARO (currentViolationGroups ke neeche)
//       const currentViolationDetails = (violationDataRef.current?.data?.details || []).map((detail, dIdx) => ({
//         detail_type: violationDetailTypeRefs.current?.[dIdx]?.value || detail.detail_type || '',
//         columns: (detail.columns || []).map((col, cIdx) =>
//           violationDetailColumnsRefs.current?.[dIdx]?.[cIdx]?.value || col || ''
//         ),
//         values: (detail.values || []).map((val, vIdx) =>
//           violationDetailValuesRefs.current?.[dIdx]?.[vIdx]?.value || val || ''
//         )
//       }));

//       // Build statistics rows from refs
//       const currentStatisticsRows = (statisticsDataRef.current?.data?.rows || []).map((row, rIdx) => ({
//         area: statisticsAreaRefs.current[rIdx]?.value || row.area || '',
//         parking_spaces: statisticsSpacesRefs.current[rIdx]?.value || row.parking_spaces || ''
//       }));

//       const tables = [
//         {
//           table_key: profileDataRef.current?.table_key || cfg.profileKey,
//           title: profileDataRef.current?.title || cfg.profileFallback.title,
//           data: {
//             total_bays: { label: 'Total On-Street Parking Bays', value: currentTotalBays },
//             contract_term: { value: currentContractTerm },
//             contract_period: { start_date: currentStartDate, end_date: currentEndDate },
//             operational_hours: { value: currentOperationalHoursValue, from: currentOperationalHoursFrom, to: currentOperationalHoursTo },
//             closed_days: { value: currentClosedDays },
//             rate_per_hour: { value: currentRatePerHour }
//           }
//         },
//         {
//           table_key: assetsDataRef.current?.table_key || cfg.assetsKey,
//           title: assetsDataRef.current?.title || cfg.assetsFallback.title,
//           data: { groups: transformAssetsToApiFormat() }
//         },
//         {
//           table_key: violationDataRef.current?.table_key || cfg.violationKey,
//           title: violationDataRef.current?.title || cfg.violationFallback.title,
//           data: {
//             violation_groups: currentViolationGroups,
//             details: currentViolationDetails  // YAHAN CHANGE HUA HAI
//           }
//         },
//         {
//           table_key: statisticsDataRef.current?.table_key || cfg.statisticsKey,
//           title: statisticsDataRef.current?.title || cfg.statisticsFallback.title,
//           data: { rows: currentStatisticsRows }
//         },
//       ];

//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, year, month: monthNumber, created_by: 1, tables
//       });

//       if (!res?.success) throw new Error(res?.message);
//       // toast.success('Data saved successfully');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   if (!profileData || !assetsData || !violationData || !statisticsData) {
//     return <LoadingComponent />;
//   }

//   const pd = profileData.data;
//   const flatAssets = groupsToFlat(assetsData.data.groups);

//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
//           <img src={DigitalCity} alt="Digital City Logo" style={{ height: '50px', objectFit: 'contain' }} />
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileData.title}</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//         {/* ══ LEFT ══ */}
//         <div className="flex-1 pr-4">

//           {/* Activities */}
//           <div className="mb-4">
//             <p className="text-[18px] font-sm mb-10">Activities:</p>
//             <div className="flex gap-8">
//               {['On Street', 'Enforcement'].map(label => (
//                 <div key={label} className="flex flex-col items-center gap-2">
//                   <div className="w-44 h-32 flex items-center justify-center">
//                     {label === 'On Street'
//                       ? <img src={OnStreet} alt="On Street" style={{ height: '200px', objectFit: 'contain' }} />
//                       : <img src={Enforcement} alt="Enforcement" style={{ height: '200px', objectFit: 'contain' }} />}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Profile Info */}
//           <div className="flex items-start gap-4 mb-4 mt-10">
//             <div className="flex-shrink-0">
//               <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
//             </div>
//             <div className="flex flex-col gap-1">
//               <div className="flex items-center gap-2">
//                 <span className="text-[12px]">
//                   Total On-Street Parking Bays{' '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={pd.total_bays?.value || ''}
//                       ref={totalBaysRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-16"
//                     />
//                   </strong>
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-4">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center flex-wrap gap-1">
//                   Contract term{' '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={pd.contract_term?.value || ''}
//                       ref={contractTermRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13"
//                     />
//                   </strong>
//                   ; start date{' '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={pd.contract_period?.start_date || ''}
//                       ref={contractStartDateRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-22"
//                     />
//                   </strong>
//                   {' to '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={pd.contract_period?.end_date || ''}
//                       ref={contractEndDateRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-32"
//                     />
//                   </strong>
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-4">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center flex-wrap gap-1">
//                   Operational Hours{' '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={pd.operational_hours?.value || ''}
//                       ref={operationalHoursValueRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-25"
//                     />
//                   </strong>
//                   {' '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={pd.operational_hours?.from || ''}
//                       ref={operationalHoursFromRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-8"
//                     />
//                   </strong>
//                   {' Hours to '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={pd.operational_hours?.to || ''}
//                       ref={operationalHoursToRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-8"
//                     />
//                   </strong>
//                   {' Hours'}
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-8">
//                 <span className="text-[12px] italic text-gray-600">
//                   <input
//                     type="text"
//                     defaultValue={pd.closed_days?.value || ''}
//                     ref={closedDaysRef}
//                     onChange={autoSave}
//                     className="outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] italic text-gray-600 w-64"
//                   />
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-4">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px]">
//                   Rate per Hour{' '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={pd.rate_per_hour?.value || ''}
//                       ref={ratePerHourRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-52"
//                     />
//                   </strong>
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-4">
//                 <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                 <span className="text-[12px]">Assets Deployed</span>
//               </div>
//             </div>
//           </div>

//           {/* Bottom: Statistics + Violations side by side */}
//           <div className="flex gap-2 mt-2 items-start">

//             {/* LEFT TABLE */}
//             <div className="flex-shrink-0">
//               <div className=" text-[9px] ">


//                 {/* <div className=" text-start ml-2 font-bold py-1  text-[9px]">
//                   {statisticsData.title}
//                 </div> */}

//                 <table className="">
//                   <thead>
//                     <tr>
//                       <th className='!border !border-b-0 text-left px-2' colSpan={2}>{statisticsData.title}</th>
//                     </tr>
//                   </thead>
//                   <thead>
//                     <tr className="bg-gray-300">
//                       <th className="!border !border-black px-4 py-1 text-left font-bold">
//                         AREA
//                       </th>
//                       <th className="!border !border-black px-4 py-1 text-center font-bold">
//                         PARKING SPACES
//                       </th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {statisticsData.data.rows.map((row, rIdx) => (
//                       <tr key={rIdx} className={row.area === 'TOTAL' ? ' font-bold' : ''}>

//                         <td className="!border !border-black px-3 py-0">
//                           <input
//                             type="text"
//                             defaultValue={row.area || ''}
//                             ref={(el) => { statisticsAreaRefs.current[rIdx] = el; }}
//                             onChange={autoSave}
//                             className="w-full bg-transparent outline-none text-[9px]"
//                           />
//                         </td>

//                         <td className="!border !border-black px-0 py-0 text-center">
//                           <input
//                             type="text"
//                             defaultValue={row.parking_spaces || ''}
//                             ref={(el) => { statisticsSpacesRefs.current[rIdx] = el; }}
//                             onChange={autoSave}
//                             className="w-full text-center bg-transparent outline-none text-[9px]"
//                           />
//                         </td>

//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* RIGHT TABLE */}
//             <div className="flex-1 !border-r !border-black">
//               <div className=" text-[9px] ">

//                 {/* Title */}
//                 {/* <div className=" text-center font-bold py-1 !border !border-black  text-[9px]">
//                   {violationData.title}
//                 </div> */}

//                 <table className="w-full table-fixed ">

//                   <thead>
//                     {/* Top Header */}
//                     <tr>
//                       <th
//                         colSpan={2}
//                         className="!border !border-black !border-r-0 px-4 py-1 text-left font-bold"
//                       >
//                         {violationData.title}
//                       </th>
//                     </tr>


//                   </thead>
//                   <thead>
//                     {/* Top Header */}
//                     <tr>
//                       <th
//                         colSpan={2}
//                         className="!border !border-black !border-r-0  px-4 py-1 text-left font-bold"
//                       >
//                         On Street Violation
//                       </th>
//                     </tr>


//                   </thead>

//                   <tbody >

//                     <div className="border border-black text-[9px]">

//                       {/* Header */}
//                       <div className="flex border-b border-black font-bold">
//                         <div className="w-[70%] !border-s px-2 py-1 bg-gray-300">
//                           Violation Types
//                         </div>
//                         <div className=" bg-gray-300 w-[30%] px-2 py-1 text-center  !border !border-black !border-t-0 !border-b-0  ">
//                           Amount
//                         </div>
//                       </div>

//                       {violationData.data.violation_groups.map((group, gIdx) => {

//                         if (!violationGroupRefs.current[gIdx]) violationGroupRefs.current[gIdx] = [];
//                         if (!violationAmountRefs.current[gIdx]) violationAmountRefs.current[gIdx] = [];

//                         return (
//                           <div key={gIdx}>

//                             {/* GROUP TITLE */}
//                             <div className="!border !border-b-0 !border-black px-2 py-1 font-bold">
//                               {group.group_name}
//                             </div>

//                             {/* ROWS */}
//                             {group.rows.map((row, rIdx) => (
//                               <div key={rIdx} className="flex ">

//                                 {/* Violation Type */}
//                                 <div className="!border !border-b-0 !border-r-0 !border-black w-[70%] border-r border-black px-2 py-1">
//                                   {/* <input
//                                     type="text"
//                                     defaultValue={row.violation_type || ''}
//                                     ref={(el) => {
//                                       violationGroupRefs.current[gIdx][rIdx] = {
//                                         ...violationGroupRefs.current[gIdx][rIdx],
//                                         type: el
//                                       };
//                                     }}
//                                     onChange={autoSave}
//                                     className="w-full bg-transparent outline-none"
//                                   /> */}
//                                   <textarea
//                                     defaultValue={row.violation_type || ''}
//                                     ref={(el) => {
//                                       violationGroupRefs.current[gIdx][rIdx] = {
//                                         ...violationGroupRefs.current[gIdx][rIdx],
//                                         type: el
//                                       };
//                                     }}
//                                     onChange={autoSave}
//                                     rows={1}
//                                     className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
//                                     style={{
//                                       // width: w,          // same as input width
//                                       minWidth: '260px', // same as your first snippet
//                                       minHeight: '22px',
//                                       lineHeight: '1.2',
//                                       padding: '3px 4px',
//                                     }}
//                                   />
//                                 </div>

//                                 {/* Amount */}
//                                 <div className="!border !border-black !border-b-0 w-[30%] px-2 py-1 bg-white text-center">
//                                   <input
//                                     type="text"
//                                     defaultValue={row.amount || ''}
//                                     ref={(el) => {
//                                       violationAmountRefs.current[gIdx][rIdx] = {
//                                         ...violationAmountRefs.current[gIdx][rIdx],
//                                         amount: el
//                                       };
//                                     }}
//                                     onChange={autoSave}
//                                     className="w-full bg-transparent outline-none text-center"
//                                   />
//                                 </div>

//                               </div>
//                             ))}

//                           </div>
//                         );
//                       })}
//                     </div>
//                     <div className='bg-white '></div>

//                     {/* DETAILS HEADER */}
//                     {/* DETAILS HEADER */}
//                     <tr>
//                       <td className="!border !border-black px-4 py-1 font-bold bg-gray-300">
//                         Details
//                       </td>
//                       <td className="!border !border-black !border-r-0 px-0 py-1 font-bold text-center bg-gray-300">
//                         Amount
//                       </td>
//                     </tr>

//                     {/* DETAILS ROWS - EDITABLE */}
//                     {violationData.data.details && violationData.data.details.map((detail, dIdx) => {
//                       // Initialize refs
//                       if (!violationDetailColumnsRefs.current[dIdx]) violationDetailColumnsRefs.current[dIdx] = [];
//                       if (!violationDetailValuesRefs.current[dIdx]) violationDetailValuesRefs.current[dIdx] = [];

//                       return (
//                         <tr key={dIdx}>
//                           <td className="!border !border-black !border-r-0 px-3 py-1 align-top">
//                             <textarea
//                               defaultValue={detail.detail_type || ''}
//                               ref={(el) => {
//                                 violationDetailTypeRefs.current[dIdx] = el;
//                               }}
//                               onChange={autoSave}
//                               rows={2}
//                               className="w-full bg-transparent outline-none text-[9px] resize-none"
//                               style={{ minHeight: '40px' }}
//                             />
//                           </td>
//                           <td className="!border !border-black !border-r-0  px-0 py-0">
//                             <table className="w-full text-[9px]">
//                               <tbody>
//                                 {/* Column Headers Row */}
//                                 <tr>
//                                   {detail.columns && detail.columns.map((col, cIdx) => (
//                                     <td key={cIdx} className={`!border !border-l-0 !border-t-0 !border-b-0  !border-black px-1 py-1 text-center ${detail.columns.length === cIdx+1 && "!border-r-0"}`}>
//                                       <textarea
//                                         defaultValue={col || ''}
//                                         ref={(el) => {
//                                           violationDetailColumnsRefs.current[dIdx][cIdx] = el;
//                                         }}
//                                         onChange={autoSave}
//                                         rows={1}
//                                         className="w-full bg-transparent outline-none text-center text-[9px] resize-none"
//                                         style={{ minHeight: '30px' }}
//                                       />
//                                     </td>
//                                   ))}
//                                 </tr>
//                                 {/* Values Row */}
//                                 <tr>
//                                   {detail.values && detail.values.map((val, vIdx) => (
//                                     <td key={vIdx} className={`!border !border-black !border-l-0 !border-b-0 px-1 py-1 text-center ${detail.values.length === vIdx+1 && "!border-r-0"}`}>
//                                       <input
//                                         type="text"
//                                         defaultValue={val || ''}
//                                         ref={(el) => {
//                                           violationDetailValuesRefs.current[dIdx][vIdx] = el;
//                                         }}
//                                         onChange={autoSave}
//                                         className="w-full bg-transparent outline-none text-center text-[9px]"
//                                       />
//                                     </td>
//                                   ))}
//                                 </tr>
//                               </tbody>
//                             </table>
//                           </td>
//                         </tr>
//                       );
//                     })}

//                   </tbody>
//                 </table>
//               </div>
//             </div>

//           </div>
//         </div>

//         {/* ══ RIGHT — Assets Panel ══ */}
//         <AssetsPanel
//           assetsTable={assetsData}
//           flatAssets={flatAssets}
//           subCountRefs={assetSubCountRefs}
//           totalCountRefs={assetTotalCountRefs}
//           onSubCount={(index, value) => {
//             const updatedFlat = [...flatAssets];
//             updatedFlat[index] = { ...updatedFlat[index], subCount: value };
//             setAssetsData(prev => ({
//               ...prev,
//               data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//             }));
//             assetsDataRef.current = {
//               ...assetsDataRef.current,
//               data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//             };
//             autoSave();
//           }}
//           onTotalCount={(index, value) => {
//             const updatedFlat = [...flatAssets];
//             updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
//             setAssetsData(prev => ({
//               ...prev,
//               data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//             }));
//             assetsDataRef.current = {
//               ...assetsDataRef.current,
//               data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//             };
//             autoSave();
//           }}
//         />
//       </div>

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default DigitalCityOnStreetProfile;











import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import DigitalCity from '@/assets/img/DigitalCity.png';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import CarPark from '@/assets/img/TaifContract-carPark.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import LoadingComponent from '@/components/common/LoadingComponent';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser', group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier', group_total_qty: o.ticketVerifier ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's", group_total_qty: o.apms ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
    { group_name: 'PIN Pad', group_total_qty: o.pinPad ?? '-', items: [{ item_name: 'IUP250', qty: o.iup250 ?? '-' }] },
    { group_name: 'Card Reader', group_total_qty: o.cardReader ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
    { group_name: 'B-Contactless', group_total_qty: o.bContactless ?? '-', items: [{ item_name: 'IUC150', qty: o.iuc150 ?? '-' }] },
    { group_name: 'RFID Reader', group_total_qty: o.rfidReader ?? '-', items: [] },
    { group_name: 'IP Barrier', group_total_qty: o.ipBarrier ?? '-', items: [] },
    { group_name: 'ANPR CAMERA', group_total_qty: o.anprCamera ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: '-' }] },
    { group_name: 'Sliding Gate', group_total_qty: o.slidingGate ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
    { group_name: "PND's", group_total_qty: o.pnds ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device', group_total_qty: '-', items: [{ item_name: 'CN-51', qty: '-' }] },
    { group_name: 'Enf Device', group_total_qty: o.enfDevice ?? '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
    { group_name: 'Validation', group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
    { group_name: 'Printer', group_total_qty: o.printer ?? '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
    { group_name: 'Tow Truck', group_total_qty: o.towTruck ?? '-', items: [] },
    { group_name: 'Clamp Vehicle', group_total_qty: o.clampVehicle ?? '-', items: [] },
    { group_name: 'Support Vehicle', group_total_qty: o.supportVehicle ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const DIGITAL_CITY_ON_STREET_CONFIG = {
  digital_city_on_street_profile: {
    profileKey: 'digital_city_on_street_profile',
    violationKey: 'digital_city_on_street_violations',
    statisticsKey: 'digital_city_on_street_statistics',
    assetsKey: 'digital_city_on_street_assets',
    pageType: 'on_street',

    profileFallback: {
      table_key: 'digital_city_on_street_profile',
      title: 'Digital City On Street - Profile',
      data: {
        total_bays: { label: 'Total On-Street Parking Bays', value: '328' },
        contract_term: { value: '05 years' },
        contract_period: { start_date: '01st April 2025', end_date: '31st March 2030' },
        operational_hours: { value: '12 Hours Per day', from: '6:00', to: '18:00' },
        closed_days: { value: '(Friday and Saturday Closed)' },
        rate_per_hour: { value: 'SAR 10 per hour + 15% vat' },
      },
    },

    violationFallback: {
      table_key: 'digital_city_on_street_violations',
      title: 'ON STREET VIOLATIONS',
      data: {
        violation_groups: [
          {
            group_name: '1st Violation Group',
            rows: [
              { violation_type: 'Parking without paying', amount: '200' },
              { violation_type: 'Expired Ticket', amount: '100' },
              { violation_type: 'Exceeding the maximum time allowed to park', amount: '100' },
              { violation_type: 'Not parked within the parking space', amount: '100' },
            ],
          },
          {
            group_name: '2nd Violation Group',
            rows: [
              { violation_type: 'Parked in an official reserved space', amount: '300' },
              { violation_type: 'Parked in a prohibited parking space', amount: '300' },
            ],
          },
          {
            group_name: '3rd Violation Group',
            rows: [
              { violation_type: 'Placing obstacles or reservations on the parking space', amount: '400' },
            ],
          },
          {
            group_name: '4th Violation Group',
            rows: [
              { violation_type: 'Parking in front of doorway, pedestrian crossing, building vehicle entry and exit lanes', amount: '900' },
              { violation_type: 'Parked the Vehicle on pedestrian area, double parking or buildings\' entries and exits', amount: '500' },
            ],
          },
        ],
        details: [
          {
            detail_type: 'Towing / Removals',
            columns: ['Light Vehicle', 'Large Vehicle', 'Daily Storage - Light vehicle', 'Daily Storage - Large vehicle (from day2)'],
            values: ['300', '1000', '', '300'],
          },
          {
            detail_type: 'Clamp removal fee',
            columns: ['Light Vehicles / Motorbikes', 'Large Vehicles/Buses, Trucks, and Vans'],
            values: ['300', '1000'],
          },
        ],
      },
    },

    statisticsFallback: {
      table_key: 'digital_city_on_street_statistics',
      title: 'PARKING STATISTICS',
      data: {
        rows: [
          { area: 'ON STREET PARKING', parking_spaces: '247' },
          { area: 'TE-01 (PART 1)', parking_spaces: '221' },
          { area: 'MASJID PARKING', parking_spaces: '13' },
          { area: 'BUILDING FORECOURT', parking_spaces: '68' },
          { area: 'TOTAL', parking_spaces: '594' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'digital_city_on_street_assets',
      title: 'Digital City On-Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '1', evDipG100: '1',
          apms: '-', pinPad: '30', iup250: '30',
          cardReader: '-', bContactless: '30', iuc150: '30',
          rfidReader: '-', ipBarrier: '-', anprCamera: '-',
          slidingGate: '2', right: '1', left: '1',
          pnds: '-', enfDevice: '8', doogee: '8',
          printer: '12', bixolon: '12',
          towTruck: '-', clampVehicle: '-', supportVehicle: '1',
        }),
      },
    },
  },
};

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const DigitalCityOnStreetProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = DIGITAL_CITY_ON_STREET_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileData, setProfileData] = useState(null);
  const [assetsData, setAssetsData] = useState(null);
  const [violationData, setViolationData] = useState(null);
  const [statisticsData, setStatisticsData] = useState(null);
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileData?.data?.total_bays?.value ?? '328';

  // Refs for profile inputs
  // 🔥 REMOVED: totalBaysRef (ab readonly hai)
  const contractTermRef = useRef(null);
  const contractStartDateRef = useRef(null);
  const contractEndDateRef = useRef(null);
  const operationalHoursValueRef = useRef(null);
  const operationalHoursFromRef = useRef(null);
  const operationalHoursToRef = useRef(null);
  const closedDaysRef = useRef(null);
  const ratePerHourRef = useRef(null);

  // Refs for violation groups
  const violationGroupRefs = useRef([]);
  const violationAmountRefs = useRef([]);

  // Refs for statistics
  const statisticsAreaRefs = useRef([]);
  const statisticsSpacesRefs = useRef([]);

  // Refs for assets
  const assetSubCountRefs = useRef([]);
  const assetTotalCountRefs = useRef([]);

  // State refs for data
  const profileDataRef = useRef(null);
  const assetsDataRef = useRef(null);
  const violationDataRef = useRef(null);
  const statisticsDataRef = useRef(null);

  const violationDetailTypeRefs = useRef([]);
  const violationDetailColumnsRefs = useRef([]);
  const violationDetailValuesRefs = useRef([]);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params
      const secondApiParams = {
        contract: "1501005",
        year: year,
        month: month,
        device_onstreet: "DC",
        type: "on_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        const profile = find(cfg.profileKey, cfg.profileFallback);
        const assets = find(cfg.assetsKey, cfg.assetsFallback);
        const violation = find(cfg.violationKey, cfg.violationFallback);
        const statistics = find(cfg.statisticsKey, cfg.statisticsFallback);

        setProfileData(profile);
        setAssetsData(assets);
        setViolationData(violation);
        setStatisticsData(statistics);

        profileDataRef.current = profile;
        assetsDataRef.current = assets;
        violationDataRef.current = violation;
        statisticsDataRef.current = statistics;
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // Auto-save
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  const transformAssetsToApiFormat = () => {
    const currentAssets = assetsDataRef.current?.data?.groups || [];
    const groups = [];
    let currentGroup = null;
    let flatIdx = 0;

    currentAssets.forEach((group) => {
      currentGroup = {
        group_name: group.group_name,
        group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
        items: []
      };
      flatIdx++;

      (group.items || []).forEach((item) => {
        currentGroup.items.push({
          item_name: item.item_name,
          qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
        });
        flatIdx++;
      });

      groups.push(currentGroup);
    });

    return groups;
  };

  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      // 🔥 totalBays - ab read-only value use karo
      const currentTotalBays = effectiveTotalBays;
      const currentContractTerm = contractTermRef.current?.value || profileDataRef.current?.data?.contract_term?.value || '';
      const currentStartDate = contractStartDateRef.current?.value || profileDataRef.current?.data?.contract_period?.start_date || '';
      const currentEndDate = contractEndDateRef.current?.value || profileDataRef.current?.data?.contract_period?.end_date || '';
      const currentOperationalHoursValue = operationalHoursValueRef.current?.value || profileDataRef.current?.data?.operational_hours?.value || '';
      const currentOperationalHoursFrom = operationalHoursFromRef.current?.value || profileDataRef.current?.data?.operational_hours?.from || '';
      const currentOperationalHoursTo = operationalHoursToRef.current?.value || profileDataRef.current?.data?.operational_hours?.to || '';
      const currentClosedDays = closedDaysRef.current?.value || profileDataRef.current?.data?.closed_days?.value || '';
      const currentRatePerHour = ratePerHourRef.current?.value || profileDataRef.current?.data?.rate_per_hour?.value || '';

      // Build violation groups from refs
      const currentViolationGroups = (violationDataRef.current?.data?.violation_groups || []).map((group, gIdx) => ({
        group_name: group.group_name,
        rows: (group.rows || []).map((row, rIdx) => ({
          violation_type: violationGroupRefs.current[gIdx]?.[rIdx]?.type?.value || row.violation_type || '',
          amount: violationAmountRefs.current[gIdx]?.[rIdx]?.amount?.value || row.amount || ''
        }))
      }));

      const currentViolationDetails = (violationDataRef.current?.data?.details || []).map((detail, dIdx) => ({
        detail_type: violationDetailTypeRefs.current?.[dIdx]?.value || detail.detail_type || '',
        columns: (detail.columns || []).map((col, cIdx) =>
          violationDetailColumnsRefs.current?.[dIdx]?.[cIdx]?.value || col || ''
        ),
        values: (detail.values || []).map((val, vIdx) =>
          violationDetailValuesRefs.current?.[dIdx]?.[vIdx]?.value || val || ''
        )
      }));

      // Build statistics rows from refs
      const currentStatisticsRows = (statisticsDataRef.current?.data?.rows || []).map((row, rIdx) => ({
        area: statisticsAreaRefs.current[rIdx]?.value || row.area || '',
        parking_spaces: statisticsSpacesRefs.current[rIdx]?.value || row.parking_spaces || ''
      }));

      const tables = [
        {
          table_key: profileDataRef.current?.table_key || cfg.profileKey,
          title: profileDataRef.current?.title || cfg.profileFallback.title,
          data: {
            total_bays: { label: 'Total On-Street Parking Bays', value: currentTotalBays },
            contract_term: { value: currentContractTerm },
            contract_period: { start_date: currentStartDate, end_date: currentEndDate },
            operational_hours: { value: currentOperationalHoursValue, from: currentOperationalHoursFrom, to: currentOperationalHoursTo },
            closed_days: { value: currentClosedDays },
            rate_per_hour: { value: currentRatePerHour }
          }
        },
        {
          table_key: assetsDataRef.current?.table_key || cfg.assetsKey,
          title: assetsDataRef.current?.title || cfg.assetsFallback.title,
          data: { groups: transformAssetsToApiFormat() }
        },
        {
          table_key: violationDataRef.current?.table_key || cfg.violationKey,
          title: violationDataRef.current?.title || cfg.violationFallback.title,
          data: {
            violation_groups: currentViolationGroups,
            details: currentViolationDetails
          }
        },
        {
          table_key: statisticsDataRef.current?.table_key || cfg.statisticsKey,
          title: statisticsDataRef.current?.title || cfg.statisticsFallback.title,
          data: { rows: currentStatisticsRows }
        },
      ];

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, year, month: monthNumber, created_by: 1, tables
      });

      if (!res?.success) throw new Error(res?.message);
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  if (!profileData || !assetsData || !violationData || !statisticsData) {
    return <LoadingComponent />;
  }

  const pd = profileData.data;
  const flatAssets = groupsToFlat(assetsData.data.groups);

  return (
    <div className="min-h-screen p-8 bg-white">

      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={DigitalCity} alt="Digital City Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileData.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-3">

        {/* ══ LEFT ══ */}
        <div className="flex-1 pr-4">

          {/* Activities */}
          <div className="mb-4">
            <p className="text-[18px] font-sm mb-10">Activities:</p>
            <div className="flex gap-8">
              {['On Street', 'Enforcement'].map(label => (
                <div key={label} className="flex flex-col items-center gap-2">
                  <div className="w-44 h-32 flex items-center justify-center">
                    {label === 'On Street'
                      ? <img src={OnStreet} alt="On Street" style={{ height: '200px', objectFit: 'contain' }} />
                      : <img src={Enforcement} alt="Enforcement" style={{ height: '200px', objectFit: 'contain' }} />}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Profile Info */}
          <div className="flex items-start gap-4 mb-4 mt-10">
            <div className="flex-shrink-0">
              <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
            </div>
            <div className="flex flex-col gap-1">
              {/* 🔥 READ-ONLY Total Bays - Second API se aayega */}
              <div className="flex items-center gap-2">
                <span className="text-[12px]">
                  Total On-Street Parking Bays{' '}
                  <strong>
                    <input
                      type="text"
                      value={effectiveTotalBays}
                      readOnly
                      disabled
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default"
                    />
                  </strong>
                </span>
              </div>

              {/* Contract Term - Editable */}
              <div className="flex items-center gap-2 ml-4">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center flex-wrap gap-1">
                  Contract term{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.contract_term?.value || ''}
                      ref={contractTermRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13"
                    />
                  </strong>
                  ; start date{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.contract_period?.start_date || ''}
                      ref={contractStartDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-22"
                    />
                  </strong>
                  {' to '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.contract_period?.end_date || ''}
                      ref={contractEndDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-32"
                    />
                  </strong>
                </span>
              </div>

              {/* Operational Hours - Editable */}
              <div className="flex items-center gap-2 ml-4">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center flex-wrap gap-1">
                  Operational Hours{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.operational_hours?.value || ''}
                      ref={operationalHoursValueRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-25"
                    />
                  </strong>
                  {' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.operational_hours?.from || ''}
                      ref={operationalHoursFromRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-8"
                    />
                  </strong>
                  {' Hours to '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.operational_hours?.to || ''}
                      ref={operationalHoursToRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-8"
                    />
                  </strong>
                  {' Hours'}
                </span>
              </div>

              {/* Closed Days - Editable */}
              <div className="flex items-center gap-2 ml-8">
                <span className="text-[12px] italic text-gray-600">
                  <input
                    type="text"
                    defaultValue={pd.closed_days?.value || ''}
                    ref={closedDaysRef}
                    onChange={autoSave}
                    className="outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] italic text-gray-600 w-64"
                  />
                </span>
              </div>

              {/* Rate per Hour - Editable */}
              <div className="flex items-center gap-2 ml-4">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  Rate per Hour{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={pd.rate_per_hour?.value || ''}
                      ref={ratePerHourRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-52"
                    />
                  </strong>
                </span>
              </div>

              {/* Assets Deployed */}
              <div className="flex items-center gap-2 ml-4">
                <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                <span className="text-[12px]">Assets Deployed</span>
              </div>
            </div>
          </div>

          {/* Bottom: Statistics + Violations side by side */}
          <div className="flex gap-2 mt-2 items-start">

            {/* LEFT TABLE - Statistics (Editable) */}
            <div className="flex-shrink-0">
              <div className="text-[9px]">
                <table className="">
                  <thead>
                    <tr>
                      <th className='!border !border-b-0 text-left px-2' colSpan={2}>{statisticsData.title}</th>
                    </tr>
                  </thead>
                  <thead>
                    <tr className="bg-gray-300">
                      <th className="!border !border-black px-4 py-1 text-left font-bold">AREA</th>
                      <th className="!border !border-black px-4 py-1 text-center font-bold">PARKING SPACES</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statisticsData.data.rows.map((row, rIdx) => (
                      <tr key={rIdx} className={row.area === 'TOTAL' ? ' font-bold' : ''}>
                        <td className="!border !border-black px-3 py-0">
                          <input
                            type="text"
                            defaultValue={row.area || ''}
                            ref={(el) => { statisticsAreaRefs.current[rIdx] = el; }}
                            onChange={autoSave}
                            className="w-full bg-transparent outline-none text-[9px]"
                          />
                        </td>
                        <td className="!border !border-black px-0 py-0 text-center">
                          <input
                            type="text"
                            defaultValue={row.parking_spaces || ''}
                            ref={(el) => { statisticsSpacesRefs.current[rIdx] = el; }}
                            onChange={autoSave}
                            className="w-full text-center bg-transparent outline-none text-[9px]"
                          />
                        </td>
                       </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* RIGHT TABLE - Violations (Editable) */}
            <div className="flex-1 !border-r !border-black">
              <div className="text-[9px]">
                <table className="w-full table-fixed">
                  <thead>
                    <tr>
                      <th colSpan={2} className="!border !border-black !border-r-0 px-4 py-1 text-left font-bold">
                        {violationData.title}
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={2} className="!border !border-black !border-r-0 px-4 py-1 text-left font-bold">
                        On Street Violation
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <div className="border border-black text-[9px]">
                      <div className="flex border-b border-black font-bold">
                        <div className="w-[70%] !border-s px-2 py-1 bg-gray-300">Violation Types</div>
                        <div className="bg-gray-300 w-[30%] px-2 py-1 text-center !border !border-black !border-t-0 !border-b-0">Amount</div>
                      </div>
                      {violationData.data.violation_groups.map((group, gIdx) => {
                        if (!violationGroupRefs.current[gIdx]) violationGroupRefs.current[gIdx] = [];
                        if (!violationAmountRefs.current[gIdx]) violationAmountRefs.current[gIdx] = [];
                        return (
                          <div key={gIdx}>
                            <div className="!border !border-b-0 !border-black px-2 py-1 font-bold">{group.group_name}</div>
                            {group.rows.map((row, rIdx) => (
                              <div key={rIdx} className="flex">
                                <div className="!border !border-b-0 !border-r-0 !border-black w-[70%] border-r border-black px-2 py-1">
                                  <textarea
                                    defaultValue={row.violation_type || ''}
                                    ref={(el) => {
                                      violationGroupRefs.current[gIdx][rIdx] = {
                                        ...violationGroupRefs.current[gIdx][rIdx],
                                        type: el
                                      };
                                    }}
                                    onChange={autoSave}
                                    rows={1}
                                    className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
                                    style={{ minWidth: '260px', minHeight: '22px', lineHeight: '1.2', padding: '3px 4px' }}
                                  />
                                </div>
                                <div className="!border !border-black !border-b-0 w-[30%] px-2 py-1 bg-white text-center">
                                  <input
                                    type="text"
                                    defaultValue={row.amount || ''}
                                    ref={(el) => {
                                      violationAmountRefs.current[gIdx][rIdx] = {
                                        ...violationAmountRefs.current[gIdx][rIdx],
                                        amount: el
                                      };
                                    }}
                                    onChange={autoSave}
                                    className="w-full bg-transparent outline-none text-center"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                    <div className='bg-white'></div>

                    {/* Details Rows */}
                    <tr>
                      <td className="!border !border-black px-4 py-1 font-bold bg-gray-300">Details</td>
                      <td className="!border !border-black !border-r-0 px-0 py-1 font-bold text-center bg-gray-300">Amount</td>
                    </tr>
                    {violationData.data.details && violationData.data.details.map((detail, dIdx) => {
                      if (!violationDetailColumnsRefs.current[dIdx]) violationDetailColumnsRefs.current[dIdx] = [];
                      if (!violationDetailValuesRefs.current[dIdx]) violationDetailValuesRefs.current[dIdx] = [];
                      return (
                        <tr key={dIdx}>
                          <td className="!border !border-black !border-r-0 px-3 py-1 align-top">
                            <textarea
                              defaultValue={detail.detail_type || ''}
                              ref={(el) => { violationDetailTypeRefs.current[dIdx] = el; }}
                              onChange={autoSave}
                              rows={2}
                              className="w-full bg-transparent outline-none text-[9px] resize-none"
                              style={{ minHeight: '40px' }}
                            />
                          </td>
                          <td className="!border !border-black !border-r-0 px-0 py-0">
                            <table className="w-full text-[9px]">
                              <tbody>
                                <tr>
                                  {detail.columns && detail.columns.map((col, cIdx) => (
                                    <td key={cIdx} className={`!border !border-l-0 !border-t-0 !border-b-0 !border-black px-1 py-1 text-center ${detail.columns.length === cIdx+1 && "!border-r-0"}`}>
                                      <textarea
                                        defaultValue={col || ''}
                                        ref={(el) => { violationDetailColumnsRefs.current[dIdx][cIdx] = el; }}
                                        onChange={autoSave}
                                        rows={1}
                                        className="w-full bg-transparent outline-none text-center text-[9px] resize-none"
                                        style={{ minHeight: '30px' }}
                                      />
                                    </td>
                                  ))}
                                </tr>
                                <tr>
                                  {detail.values && detail.values.map((val, vIdx) => (
                                    <td key={vIdx} className={`!border !border-black !border-l-0 !border-b-0 px-1 py-1 text-center ${detail.values.length === vIdx+1 && "!border-r-0"}`}>
                                      <input
                                        type="text"
                                        defaultValue={val || ''}
                                        ref={(el) => { violationDetailValuesRefs.current[dIdx][vIdx] = el; }}
                                        onChange={autoSave}
                                        className="w-full bg-transparent outline-none text-center text-[9px]"
                                      />
                                    </td>
                                  ))}
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* ══ RIGHT — Assets Panel ══ */}
        <AssetsPanel
          assetsTable={assetsData}
          flatAssets={flatAssets}
          subCountRefs={assetSubCountRefs}
          totalCountRefs={assetTotalCountRefs}
          onSubCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], subCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
          onTotalCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
        />
      </div>
    </div>
  );
};

export default DigitalCityOnStreetProfile;